import PropTypes from "prop-types";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import SEO from "../seo";
import LayoutOne from "../../layouts/LayoutOne";
import NewsletterBar from "../newdesign/NewsletterBar";
import ProfileSidebar from "./ProfileSidebar";
import StateMessage from "./StateMessage";

/*
 * Shell shared by every profile page: breadcrumb, sidebar and a titled
 * content column. Each page supplies only its own panels.
 */
const ProfileLayout = ({
  seoTitle,
  title,
  subtitle,
  actions,
  user,
  isLoading,
  isError,
  onSignOut,
  children,
}) => (
  <Fragment>
    <SEO titleTemplate={seoTitle} description={subtitle} />

    <LayoutOne headerTop="visible">
      <main className="c4prf">
        <div className="c4wide">
          <nav className="c4prf__crumbs" aria-label="Breadcrumb">
            <Link to={process.env.PUBLIC_URL + "/"}>Home</Link>
            <span aria-hidden="true">/</span>
            <span aria-current="page">{title}</span>
          </nav>

          {isError ? (
            <StateMessage
              tone="error"
              title="Please sign in to view your profile"
              text="We couldn't confirm your session. Sign in again and we'll bring you straight back here."
            >
              <div className="c4prf__actions">
                <Link
                  className="c4prf__btn c4prf__btn--primary"
                  to={process.env.PUBLIC_URL + "/login-register"}
                >
                  Sign In
                </Link>
              </div>
            </StateMessage>
          ) : (
            <div className="c4prf__grid">
              <ProfileSidebar
                name={user?.name}
                email={user?.email}
                verified={user?.isVerified}
                onSignOut={onSignOut}
              />

              <section className="c4prf__main">
                <header className="c4prf__head">
                  <div>
                    <h1 className="c4prf__title">{title}</h1>
                    {subtitle ? (
                      <p className="c4prf__sub">{subtitle}</p>
                    ) : null}
                  </div>
                  {actions ? (
                    <div className="c4prf__head-actions">{actions}</div>
                  ) : null}
                </header>

                {isLoading ? (
                  <StateMessage
                    tone="loading"
                    title="Loading your profile…"
                    text="One moment."
                  />
                ) : (
                  children
                )}
              </section>
            </div>
          )}
        </div>
      </main>

      <NewsletterBar />
    </LayoutOne>
  </Fragment>
);

ProfileLayout.propTypes = {
  seoTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  actions: PropTypes.node,
  user: PropTypes.object,
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  onSignOut: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default ProfileLayout;
